const TravelReportAttachmentView = (props) => {
  return (
    <div className="travel-report-attachment-view">
      <img src={props.imageUrl} alt="attachment-image" />
    </div>
  );
};

export default TravelReportAttachmentView;
